import React from "react";
import "../../../styles/diwaliTheme.css";

/** Flickering diya; idPrefix keeps its gradient ids unique per place it is used. */
const DiwaliDiya = ({ idPrefix, className = "h-6 w-6" }) => {
  return (
    <svg viewBox="0 0 28 28" className={className} aria-hidden="true">
      <defs>
        <radialGradient id={`${idPrefix}-halo`}>
          <stop offset="0" stopColor="#fde68a" stopOpacity="0.9" />
          <stop offset="1" stopColor="#fde68a" stopOpacity="0" />
        </radialGradient>
        <linearGradient id={`${idPrefix}-flame`} x1="0" y1="1" x2="0" y2="0">
          <stop offset="0" stopColor="#f97316" />
          <stop offset="0.6" stopColor="#fbbf24" />
          <stop offset="1" stopColor="#fef3c7" />
        </linearGradient>
        <linearGradient id={`${idPrefix}-bowl`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#ea580c" />
          <stop offset="1" stopColor="#9a3412" />
        </linearGradient>
      </defs>
      <ellipse
        className="diwali-halo"
        cx="14"
        cy="11"
        rx="9"
        ry="9"
        fill={`url(#${idPrefix}-halo)`}
      />
      <path
        className="diwali-flame"
        d="M14 4C17 8 17 12 14 14C11 12 11 8 14 4Z"
        fill={`url(#${idPrefix}-flame)`}
      />
      <path
        d="M3 15H25C24 21 19 24 14 24C9 24 4 21 3 15Z"
        fill={`url(#${idPrefix}-bowl)`}
      />
      <path
        d="M6 18H22"
        stroke="#fde68a"
        strokeWidth="1"
        strokeDasharray="1.5 2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DiwaliDiya;
